import React, {PureComponent} from "react";
import {Button,Modal,Form,Input,Select,Option,Icon, Checkbox, message} from "@ss/mtd-react3"
import "./style.scss"
import {fetchData} from "@/utils";
import {getUserInfo} from "@/utils/index.js"
import urls from "@/urls";
import InputWithCheckBox from "@/components/repository-operate-modal/input-checkbox";
import {MemberType} from "@/utils/constant/member";


const fontClassRules = {
    message:'FontClass前缀只允许输入字母、数字、中划线和下划线，最长20个字符',
    validator(rule, value, callback, source, options){
        return value && /^[a-z0-9-_]{1,20}$/.test(value)
    }
}
export default class RepositoryOperateModal extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            directoryOptions: [],
            selectedValue: null,
            isAddingAdmin: false,
            loadingSearchMis: false,
            selectActiveMis: '',
            dataMisSource: [],
            repositoryAdmins: [],
            ignoreRepo: false,
            repoCodeInfo: {
                triggerEvent:"",
                inputValue:"icon-",
                boxChecked:true
            },
            isRepository: false,
            repositoryButtonLoading: false,
            defaultFieldsValue: {},
            repoId: 0
        }
        this.handleFilterMis = this.debounce(this.handleFilterMis.bind(this),500)
        this.formRef = React.createRef()
        this.lastMisSearchTimeStamp = 0
    }

    async componentDidMount() {
        await this.getRepositoryDirectoryList()
        const { showModal,memberType,isCreate = true,repositoryInfo } = this.props;
        const {directoryOptions} = this.state

        console.log(repositoryInfo)
        if(!isCreate){
            // 编辑态需要预填充数据
            let selectedValue = "暂无数据";
            if(directoryOptions.length > 0){
                selectedValue = Number(repositoryInfo.directoryId) === 0 ? directoryOptions[0].value : repositoryInfo.directoryId;
            }
            if(memberType === MemberType.ORGANIZATION){
                // 图标库
                this.setState({
                    defaultFieldsValue: {
                        name: repositoryInfo.name,
                        repoCode: repositoryInfo.code,
                    },
                    repositoryAdmins: repositoryInfo?.adminList ? repositoryInfo.adminList.map(item=>({id:item.userMis,userName:item.userName,avatar:item.avatar})) : [] ,
                    selectedValue,
                    repoId: repositoryInfo.id
                })
            }else{
                // 个人图标库
                this.setState({
                    defaultFieldsValue: {
                        name: repositoryInfo.name,
                        fontFamily: repositoryInfo.fontFamily,
                    },
                    repoCodeInfo: {
                        triggerEvent: "",
                        inputValue: repositoryInfo.prefix,
                        boxChecked: !repositoryInfo.ignoreRepo
                    },
                    ignoreRepo: repositoryInfo.ignoreRepo,
                    selectedValue,
                    repoId: repositoryInfo.id,
                    repositoryAdmins: repositoryInfo?.adminList ?  repositoryInfo.adminList.map(item=>({id:item.userMis,userName:item.userName,avatar:item.avatar})) : [],
                })
            }

        }else{
            // 新建态也需要预填数据
            if(memberType === MemberType.PERSON){
                const { userMis, userName, avatar } = await getUserInfo();
                this.setState({
                    defaultFieldsValue: {
                        fontFamily: 'iconfont'
                    },
                    repositoryAdmins: [{id: userMis, userName, avatar}]
                })
            }else{
                // 从localStorage获取管理员信息
                const adminInfoStr = localStorage.getItem('activeTeamMembers');
                if (adminInfoStr) {
                    try {
                        let adminInfo = JSON.parse(adminInfoStr);
                        adminInfo = adminInfo.map(item => ({
                            id: item.userMis,
                            userName: item.userName,
                            avatar: item.avatar,
                        }));
                        this.setState({
                            repositoryAdmins: adminInfo
                        });
                    } catch (e) {
                        console.error('解析管理员信息失败:', e);
                    }
                }
                // 监听localStorage变化
                window.addEventListener('activeTeamMembersChange', this.handleActiveTeamMembersChange);
            }
        }

        this.setState({
            showModal,
            isRepository: memberType === MemberType.ORGANIZATION
        })

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // if(prevState.ignoreRepo !== this.state.ignoreRepo){
        //
        // }
    }

    handleActiveTeamMembersChange = () => {
        const adminInfoStr = localStorage.getItem('activeTeamMembers');
        if (adminInfoStr) {
            let adminInfo = []
            try{
                adminInfo = JSON.parse(adminInfoStr);
                adminInfo = adminInfo.map(item => ({
                    id: item.userMis,
                    userName: item.userName,
                    avatar: item.avatar,
                }));
            }catch(e){
                console.error('解析管理员信息失败:', e);
            }
            this.setState((prevState) => {
                // 优先展示activeTeamMembers中的管理员，再展示repositoryAdmins中的管理员，并去重
                const newRepositoryAdmins = [...adminInfo, ...prevState.repositoryAdmins].filter((item, index, self) =>
                    index === self.findIndex(t => t.id === item.id)
                );
                return { repositoryAdmins: newRepositoryAdmins };
            });
        }
    }

    handleClose = () => {
        this.setState({showModal: false});
    }

    async getRepositoryDirectoryList() {
        try {
            // 1. 先尝试从缓存获取数据，提供快速响应
            const cachedData = sessionStorage.getItem("RepoDirectoryList");
            if (cachedData) {
                const directoryList = JSON.parse(cachedData);
                const directoryOptions = directoryList.map(item => ({
                    value: item.directoryId,
                    label: item.directoryName
                }));
                // 先用缓存数据渲染
                this.setState({ 
                    directoryOptions,
                    selectedValue: directoryOptions[0]?.value 
                });
            }
    
            // 2. 同时发起请求获取最新数据
            const res = await fetchData(urls.iconfont.repository.directorylist);
            const directoryList = res?.directoryList || [];
            
            // 3. 比较数据是否有变化
            const newDataStr = JSON.stringify(directoryList);
            if (newDataStr !== cachedData) {
                // 数据有更新，刷新界面并更新缓存
                const directoryOptions = directoryList.map(item => ({
                    value: item.directoryId,
                    label: item.directoryName
                }));
                this.setState({
                    directoryOptions,
                    selectedValue: this.state.selectedValue || directoryOptions[0]?.value
                });
                sessionStorage.setItem("RepoDirectoryList", newDataStr);
            }
        } catch (e) {
            console.log('获取目录列表失败:', e);
            // 4. 请求失败时，如果有缓存数据就继续使用
            if (!this.state.directoryOptions.length) {
                message.error({ message: '获取分类列表失败' });
            }
        }
    }

    handleDirectoryChange = (value) => {
        console.log(value)
        this.setState({selectedValue: value})
    }

    // 防抖
    debounce = (func,delay)=>{
        let time = null;
        return function(...args){
            clearTimeout(time);
            time = setTimeout(()=>{
                func.apply(this,args)
            },delay)
        }
    }

    handleFilterMis = async (v) => {
        if(v === '')
            return;
        const curTimeStamp = Date.now();

        this.setState({
            loadingSearchMis: true
        });
        this.lastMisSearchTimeStamp = curTimeStamp;
        const res = await fetchData(urls.budgetManagemen.all, { keyword: v });
        if(curTimeStamp !== this.lastMisSearchTimeStamp){
            // 阻止非过期请求进行数据渲染
            return;
        }
        if (res) {
            this.setState({
                dataMisSource: res,
                loadingSearchMis: false
            });
        }
    }

    handleAddAdmin = async () => {
        const { isCreate = true,activeTeam, } = this.props;
        const { selectActiveMis, dataMisSource, repositoryAdmins } = this.state;
        const activeAdmin = dataMisSource.find(item => item.mis === selectActiveMis);
        if (!activeAdmin) {
            message.error({ message: "管理员选择失败，请重新选择" });
            return
        }

        const isExist = repositoryAdmins.some(item => item.id === activeAdmin.mis);
        if(isExist){
            message.info({ message: "管理员已添加，请勿重复添加" });
            return
        }
        const newRepositoryAdmins = [...repositoryAdmins,{id:activeAdmin.mis,userName:activeAdmin.name,avatar:activeAdmin.url}]
        this.setState({repositoryAdmins: newRepositoryAdmins})
    }

    deleteAdmin = async (id) => {
        const { isCreate = true } = this.props;
        const {repositoryAdmins} = this.state;
        if(isCreate){
            // 新建态
            const newRepositoryAdmins = repositoryAdmins.filter(item => item.id !== id);
            this.setState({repositoryAdmins: newRepositoryAdmins})
        }else{
            // 编辑态-删除操作需二次确认
            Modal.warning({
                title: '删除成员',
                message: <span>确定删除该管理员？</span>,
                onOk: async () => {
                    const userInfo = await getUserInfo();
                    if(id === userInfo.userMis){
                        message.error({message: '用户不能取消自身管理员身份'});
                        return;
                    }
                    const newRepositoryAdmins = repositoryAdmins.filter(item => item.id !== id);
                    if(newRepositoryAdmins.length < 1){
                        message.error({message: '图标库至少需要有一个管理员'});
                        return;
                    }
                    this.setState({repositoryAdmins: newRepositoryAdmins})
                },
                okText: '确定',
                okBtnProps: { type: 'primary' },
                cancelText: '取消',
            })
        }

    }

    repoCodeInfoChange = (changedValue)=>{
        console.log(changedValue)
        this.setState({repoCodeInfo:changedValue})
        if(changedValue.triggeredEvent === 'checkbox'){
            if(!changedValue.boxChecked){
                // 取消库编码
                this.confirmIgnoreRepo()
            }else{
                // 加上库编码
                this.setState({
                    ignoreRepo: false,
                });
            }
        }else{

        }
    }

    confirmIgnoreRepo = () => {
        Modal.warning({
            message: '去掉库编码后生成FontClass示例：icon-图标名，可能会有图标重名风险',
            title: '强行去掉库编码有图标重名风险',
            onOk: () => {
                this.setState({
                    ignoreRepo: true,
                });
            },
            onCancel: () => {},
            maskClosable: false,
            okText: '去掉库编码',
            cancelText: '取消',
            zIndex: 8888,
        });
    }

    validateFormData = async ()=> {
        const { isRepository,ignoreRepo } = this.state;
        const { activeTeam,userId } = this.props;
        const {name,fontClass,fontFamily,repoCode} = this.formRef.current.getFieldsValue();
        if(!name || name.trim() === ''){
            message.error({message: '图标库名称不允许为空'});
            this.setState({repositoryButtonLoading: false});
            return false;
        }
        const fontClassPrefix = fontClass?.inputValue || "";

        if(!isRepository){
            const regx = /^[a-z0-9-_]{1,20}$/;
            if (!regx.test(fontClassPrefix)) {
                message.error({message:'FontClass前缀只允许输入小写字母、数字、中划线和下划线，最长20个字符'});
                this.setState({repositoryButtonLoading: false});
                return false;
            }
        }else{
            const regx = /^[a-z0-9-_]{1,10}$/;
            if (!repoCode || !regx.test(repoCode)) {
                message.error({message:'图标库编码只允许输入小写字母、数字、中划线和下划线，最长10个字符'});
                this.setState({repositoryButtonLoading: false});
                return false;
            }
        }
        const { directoryOptions,repositoryAdmins,selectedValue } = this.state;
        // if(!selectedValue || !directoryOptions.some(item=>item.value === selectedValue)){
        //     message.error({message:'请选择图标库分类'});
        //     this.setState({repositoryButtonLoading: false});
        //     return false;
        // }
        if(!repositoryAdmins || repositoryAdmins.length === 0){
            message.error({message:'至少需要有一个管理员'});
            this.setState({repositoryButtonLoading: false});
            return false;
        }
        return isRepository ? {
            name,
            repoCode,
            // directoryId: selectedValue,
            admins: repositoryAdmins.map(item=>item.id),
            isRepo: true,
            userId: Number(activeTeam.value),
        } : {
            name,
            fontClassPrefix,
            ignoreRepo: ignoreRepo,
            fontFamily,
            // directoryId: selectedValue,
            admins: repositoryAdmins.map(item=>item.id),
            userId: Number(userId),
            isRepo: false,
        };
    }

    submitRepository = async (e)=> {
        console.log(this.formRef.current.getFieldsValue())
        const {isCreate = true,afterUpdate} = this.props;
        this.setState({repositoryButtonLoading: true},async ()=>{
            // 数据校验
            let params = await this.validateFormData();
            if(!params){
                return;
            }
            // 提交
            try{
                // 编辑态需要补参id
                if(!isCreate){
                    const {repoId} = this.state;
                    params = {
                        ...params,
                        id: Number(repoId)
                    }
                }
                await fetchData(urls.iconfont.repository.editRepo,params);
                message.success({message: `图标库${isCreate ? '新建': '编辑' }成功`});
                afterUpdate && afterUpdate();   // 父组件重新渲染
                this.setState({
                    showModal: false
                })
            }catch (e){
                // message.error({message: '提交失败，请重新修改'});
                console.log(e)
            }finally{
                this.setState({repositoryButtonLoading: false})
            }
        })
    }


    render() {
        const {onModalClosed,isCreate = true} = this.props;
        const {showModal, directoryOptions,selectedValue,isAddingAdmin,loadingSearchMis,selectActiveMis,dataMisSource,repositoryAdmins,ignoreRepo,repoCodeInfo,isRepository,repositoryButtonLoading,defaultFieldsValue} = this.state;


        return (
            <Modal className="repository-operate-modal" afterClose={onModalClosed || (()=>{})} open={showModal} title={isCreate ? `新建${isRepository ? '' :'个人'}图标库` : `编辑${isRepository ? '' :'个人'}图标库`} onClose={this.handleClose} style={{width: '500px'}} zIndex={500}>
                <Modal.Body>
                    <Form colon labelPosition="right" ref={this.formRef} defaultFieldsValue={defaultFieldsValue}>
                        <Form.Item formItemKey="name" label="图标库名称">
                            <Input placeholder="请输入" toFormItem />
                        </Form.Item>
                        {isRepository ?
                            <Form.Item formItemKey="repoCode" label="图标库编码" disabled={!isCreate}
                                       helper="字母和数字组成，最多10个字符，用作图标项目里的图标生成FontClass前缀。一旦设定无法修改。">
                                <Input placeholder="请输入" toFormItem maxLength={10} showCount />
                            </Form.Item> :
                            <>
                                <Form.Item formItemKey="fontClass" label="FontClass前缀"
                                           helper="支持小写字母、数字、下划线、中划线。为避免图标重名风险，建议加上库编码">
                                    {/*使用onUpdate，不要覆写onchange，会导致form无法get数据*/}
                                    <InputWithCheckBox comValue={repoCodeInfo} onUpdate={this.repoCodeInfoChange}
                                                       checked={!ignoreRepo} toFormItem></InputWithCheckBox>
                                </Form.Item>
                                <Form.Item formItemKey="fontFamily" label="FontFamily"
                                           helper="为避免图标冲突风险，建议区分FontFamily">
                                    <Input placeholder="请输入" toFormItem/>
                                </Form.Item>
                            </>
                        }
                        {/* 不再允许用户操作图标库分类，非官方的图标库都归属于全部资产下 */}
                        {/* <Form.Item formItemKey="directory" label="所属分类">
                            <Select
                                value={selectedValue}
                                onlyKeyValue
                                filterOption
                                placeholder={'请选择'}
                                onChange={this.handleDirectoryChange}
                            >
                                {directoryOptions.map((option, index) => (
                                    <Option
                                        key={index}
                                        value={option.value}
                                        disabled={option.disabled}
                                        originOption={option}
                                    >
                                        {option.label}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item> */}
                        <Form.Item formItemKey="admin" label="管理员" className="admin-field">
                            <div className='memeber-add-area'>
                                <div className='add-opertaion-area'>
                                    {
                                        !isAddingAdmin ? <div style={{cursor: 'pointer'}}
                                                               onClick={() => this.setState({
                                                                   selectActiveMis: '',
                                                                   isAddingAdmin: true
                                                               })}>
                                                <Icon type='avatar-add' className='add-icon'></Icon>
                                                <span className='title'>新增管理员</span>
                                            </div> :
                                            <div className='add-member-detail'>
                                                <Select
                                                    style={{width: 236,height: 30}}
                                                    placeholder='请输入姓名、MIS号'
                                                    loading={loadingSearchMis}
                                                    notFoundMessage='无数据'
                                                    // onFilter={this.handleFilterMis}
                                                    onFilter={(v)=>this.handleFilterMis(v)}
                                                    value={selectActiveMis}
                                                    onChange={v => this.setState({selectActiveMis: v})}
                                                    onlyKeyValue
                                                    clearable={false}
                                                    className='search-select'
                                                    isKeywordHighlight
                                                >
                                                    {dataMisSource.map((option, index) => (
                                                        <Option key={index} value={option.mis}>
                                                            {`${option.name}/${option.mis}`}
                                                        </Option>
                                                    ))}
                                                </Select>
                                                <span className='operation-icon' onClick={() => this.setState({
                                                    isAddingAdmin: false,
                                                    dataMisSource: [],
                                                    selectActiveMis: ''
                                                })}>取消</span>
                                                <span className='operation-icon'
                                                      onClick={this.handleAddAdmin}>新增</span>
                                            </div>
                                    }
                                </div>
                                <div className='member-wrap'>
                                    <ul className='member-content'>
                                        {
                                            repositoryAdmins.map(item => (
                                                        <li key={item.id} className='member-item'>
                                                            <div>
                                                                <img src={item.avatar || 'https://p0.meituan.net/codeman/35ce660504ebd9b554e13a90090f6ddc3995.png'} loading='lazy' alt={item.mis}/>
                                                                <span>{item.userName}</span>
                                                            </div>
                                                            <Icon type='delete-o' onClick={() => {
                                                                this.deleteAdmin(item.id)
                                                            }}></Icon>
                                                        </li>
                                                    )
                                            )
                                        }
                                    </ul>
                                </div>
                            </div>
                        </Form.Item>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button type="grey" style={{marginRight: '12px'}} onClick={this.handleClose}>
                        取消
                    </Button>

                    <Button loading={repositoryButtonLoading} onClick={this.submitRepository} style={{backgroundColor:"#FFDD00",borderWidth:'0'}}>确定</Button>

                </Modal.Footer>
            </Modal>
        )
    }
}
